var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-container"},[_c('p',{staticClass:"info-message"},[_vm._v(_vm._s(_vm.infoMessage))]),_c('p',{staticClass:"contact-us",domProps:{"innerHTML":_vm._s(_vm.contactUs)}})])}
var staticRenderFns = []

export { render, staticRenderFns }